import Vue from 'vue'
import Vuex from 'vuex'

import dashboard from './modules/dashboard'
import movies from './modules/movies'
import series from './modules/series'
import servers from './modules/servers'
import captions from './modules/captions'
import users from './modules/users'
import settings from './modules/settings'

Vue.use(Vuex);

export const store = new Vuex.Store({
	  modules: {
	  	dashboard,
	  	movies,
	  	series,
	  	servers,
	  	captions,
	  	users,
	  	settings
	  }
})


// WEBPACK FOOTER //
// ./src/store/store.js